import { Component, OnInit } from '@angular/core';
import { TransactionService } from 'src/app/services/transaction.service';
import { Transaction } from 'src/app/entities/transaction';
import { slugify } from 'src/app/utils/string.utils';

@Component({
  selector: 'app-my-shopping',
  templateUrl: './my-shopping.component.html',
  styleUrls: ['./my-shopping.component.scss']
})
export class MyShoppingComponent implements OnInit {

  isLoading = true;
  transactions = new Array<Transaction>();

  myShopping: any[] = [
    {
      name: 'Zapatos Marca Nike',
      quantity: '2 unidades',
      color: 'Blanco',
      price: 2312.50,
      image: '',
      arrivesOn: '',
      delivered: 'entregado',
    },
    {
      name: 'Sofa muy cómodo y reconfortante',
      quantity: '1 unidad',
      color: 'Blanco',
      price: 3199,
      image: '/assets/img/products/product-05.webp',
      arrivesOn: '06 de enero',
      delivered: '',
    },
  ]

  constructor(
    protected transactionService: TransactionService
  ) { }

  ngOnInit() {
    this.loadTransactions();
  }

  getTotal(transaction) {
    let total = 0;
    for (const item of transaction.items) {
      total += parseFloat(item.subtotal);
    }
    return total;
  }

  getQuantity(transaction) {
    let total = 0;
    for (const item of transaction.items) {
      total += parseFloat(item.quantity);
    }
    return total;
  }

  loadTransactions() {
    this.transactionService.list().toPromise().then(data => {
      this.isLoading = false;
      if (!data.success) {
        return;
      }
      this.transactions = data.response;
    });
  }

  processProductTitle(product) {
    return slugify(product.title);
  }
}
